<template>
<b-card>
    <validation-observer ref="observer" v-slot="{ passes }">
    <b-form @submit.prevent="passes(onFormSubmit)" novalidate>
        <p class="small text-muted mb-2">Kind</p>
        <b-form-row>
            <b-col md="2"><b-form-group label="Voornamen" label-for="child_first_names"><b-form-input id="child_first_names" v-model="form.child_first_names" /></b-form-group></b-col>
            <b-col md="2">
                <b-form-group label="Geslacht" label-for="child_gender">
                    <b-form-select id="child_gender" plain v-model="form.child_gender">
                        <b-form-select-option :value="''">Select...</b-form-select-option>
                        <b-form-select-option v-for="gender in biological_genders" :key="gender.id" :value="gender.name">{{ gender.name }}</b-form-select-option>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-form-row>
        <b-form-row>
            <b-col md="2"><b-form-group label="Geboorte datum" label-for="child_dob"><b-form-datepicker id="child_dob" v-model="form.child_dob" :locale="currentLang" :max="maxDate"></b-form-datepicker></b-form-group></b-col>
            <b-col md="2"><b-form-group label="Tijd" label-for="child_time"><b-form-input id="child_time" v-model="form.child_time" /></b-form-group></b-col>
            <b-col md="2"><b-form-group label="Geboorte Plaats" label-for="child_birth_place"><b-form-input id="child_birth_place" v-model="form.child_birth_place" /></b-form-group></b-col>
        </b-form-row>

        <hr>
        <p class="small text-muted mb-2">Moeder</p>
        <b-form-row>
            <b-col md="3"><b-form-group label="Naam" label-for="mother_surname"><b-form-input id="mother_surname" v-model="form.mother_surname" /></b-form-group></b-col>
            <b-col md="3"><b-form-group label="Voornamen" label-for="mother_first_names"><b-form-input id="mother_first_names" v-model="form.mother_first_names" /></b-form-group></b-col>
        </b-form-row>
        <b-form-row>
            <b-col md="3"><b-form-group label="Geboorte Datum" label-for="mother_dob"><b-form-datepicker id="mother_dob" v-model="form.mother_dob" :locale="currentLang" :max="maxDate"></b-form-datepicker></b-form-group></b-col>
            <b-col md="3"><b-form-group label="Beroep" label-for="mother_occupation"><b-form-input id="mother_occupation" v-model="form.mother_occupation" /></b-form-group></b-col>
        </b-form-row>
        <b-form-row>
            <b-col md="3"><b-form-group label="Adres" label-for="mother_address"><b-form-input id="mother_address" v-model="form.mother_address" /></b-form-group></b-col>
            <b-col md="3">
                <b-form-group label="Geloof" label-for="mother_religion">
                    <b-form-select id="mother_religion" plain v-model="form.mother_religion">
                        <b-form-select-option :value="''">Select...</b-form-select-option>
                        <b-form-select-option v-for="religion in religions" :key="religion.id" :value="religion.name">{{ religion.name }}</b-form-select-option>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-form-row>

        <hr>
        <p class="small text-muted mb-2">Vader</p>
        <b-form-row>
            <b-col md="3"><b-form-group label="Naam" label-for="father_surname"><b-form-input id="father_surname" v-model="form.father_surname" /></b-form-group></b-col>
            <b-col md="3"><b-form-group label="Voornamen" label-for="father_first_names"><b-form-input id="father_first_names" v-model="form.father_first_names" /></b-form-group></b-col>
        </b-form-row>
        <b-form-row>
            <b-col md="3"><b-form-group label="Geboorte Datum" label-for="father_dob"><b-form-datepicker id="father_dob" v-model="form.father_dob" :locale="currentLang" :max="maxDate"></b-form-datepicker></b-form-group></b-col>
            <b-col md="3"><b-form-group label="Beroep" label-for="father_occupation"><b-form-input id="father_occupation" v-model="form.father_occupation" /></b-form-group></b-col>
        </b-form-row>
        <b-form-row>
            <b-col md="3"><b-form-group label="Adres" label-for="father_address"><b-form-input id="father_address" v-model="form.father_address" /></b-form-group></b-col>
            <b-col md="3">
                <b-form-group label="Geloof" label-for="father_religion">
                    <b-form-select id="father_religion" plain v-model="form.father_religion">
                        <b-form-select-option :value="''">Select...</b-form-select-option>
                        <b-form-select-option v-for="religion in religions" :key="religion.id" :value="religion.name">{{ religion.name }}</b-form-select-option>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-form-row>

        <hr>
        <b-col md="3" class="p-0">
            <b-form-group label="Verlosk" label-for="midwife"><b-form-input id="midwife" v-model="form.midwife" /></b-form-group>
        </b-col>

        <b-col md="3" class="p-0">
            <b-form-group
                label="Administrative date"
                label-for="administrative_datetime">
                    <b-form-datepicker id="administrative_datetime" placeholder="Set administrative date..." v-model="form.administrative_datetime" :locale="currentLang" :max="maxDate"></b-form-datepicker>
            </b-form-group>
        </b-col>

        <b-button class="mr-1" type="submit" variant="success"><i class="fa-regular fa-circle-dot"></i> Submit</b-button>
        <b-button v-if="isDirty || hasErrors" type="button" variant="danger" @click="reset"><i class="fa-solid fa-ban"></i> Reset</b-button>
    </b-form>
    </validation-observer>
</b-card>
</template>
<script>
import FormExtension from "@/core/components/FormExtension"
import { mapState, mapActions } from "vuex"

const DEFAULTS = {
    child_first_names: '',
    child_gender: '',
    child_dob: null,
    child_time: '',
    child_birth_place: '',
    mother_surname: '',
    mother_first_names: '',
    mother_dob: null,
    mother_occupation: '',
    mother_address: '',
    mother_religion: '',
    father_surname: '',
    father_first_names: '',
    father_dob: null,
    father_occupation: '',
    father_address: '',
    father_religion: '',
    midwife: '',
    administrative_datetime: null,
    consistency_token: null
}

export default FormExtension.extend({
    name: "cbbformulier-form",
    data() {
        return {
            form: new Form({ ...DEFAULTS }),
            maxDate: new Date(),
        }
    },
    computed: {
        ...mapState('catalogue', {
            religions: state => state.religions,
            biological_genders: state => state.biological_genders,
        })
    },
    watch: {
        form: {
            deep: true,
            handler(val) {
                this.isDirty = this.form.dirty()

                if (this.isDirty) {
                    this.dirty()
                }else{
                    this.validated()
                }
            }
        },
        refresh: {
            immediate: true,
            handler(val) {
                if(val) {
                   this.reset()
                }
            }
        }
    },
    methods: {
        ...mapActions('catalogue', ['getCatalogueItem']),
        async loadForPatient(patient) {
            this.newFormWithDefaults()
            await this.getCatalogueItem('religions')
            await this.getCatalogueItem('biological_genders')
        },
        onFormSubmit() {
            this.callback(this.form.data()).then(() => {
                this.reset()
                this.notify("CBB formulier created", "CBB formulier was created successfully")
                this.$emit('created')
            })
            .catch(errors => {
                if (errors.response) {
                    this.$refs.observer?.setErrors(errors.response.data)
                    this.hasErrors = true
                }
            })
        },
        newFormWithDefaults() {
            this.form = Form.create({ ...DEFAULTS })
        },
        reset() {
            this.newFormWithDefaults()

            this.$nextTick(() => {
                this.$refs.observer?.reset()
                this.hasErrors = false
                this.validated()
            })
        }
    }
})
</script>
